import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UserAvatar from '../../../../User/Avatar';
import { CommentContext } from '../../../CommentContext';
import CommentFooter from '../../../lego/CommentFooter';
import ReplyCommentBox from '../../../lego/ReplyCommentBox';
import ReadContentBlock from '../../../lego/ReadContentBlock';
import RootLayout from './RootLayout';
import s from './ReadView.scss';
/**
 * The read view for our standard comment preset.
 */
var ReadView = function (_a) {
    var canPostComment = _a.canPostComment, nc = _a.nc, _b = _a.includeFooter, includeFooter = _b === void 0 ? true : _b, onReplyPosted = _a.onReplyPosted;
    var isNewReplyButtonFlagEnabled = useFlag('new_reply_button_global');
    var isMobile = useContext(MobileContext);
    var _c = useContext(CommentContext), comment = _c.comment, isReplying = _c.isReplying;
    var user = comment.user;
    var canReply = !comment.isHidden && !comment.isSpam;
    return (React.createElement(RootLayout, { prefix: user && React.createElement(UserAvatar, { user: user, size: isMobile ? 24 : 32, withTooltip: true }), contentBlocks: [
            React.createElement(ReadContentBlock, { key: "main-content", canPostComment: canPostComment }),
            includeFooter && (React.createElement(CommentFooter, { key: "footer", className: c(!isNewReplyButtonFlagEnabled && s['footer']), canPostComment: canPostComment })),
            isReplying && canReply && (React.createElement(ReplyCommentBox, { key: "reply", nc: nc, className: s['reply-block'], onReplyPosted: onReplyPosted, canPostComment: canPostComment })),
        ] }));
};
ReadView.displayName = 'ReadView';
export default ReadView;
//# sourceMappingURL=ReadView.js.map